export default __webpack_public_path__ + "static/media/finished_img_052.53a11746.jpg";